import AccountholderStorageProvider from 'front-office/hooks/storage/provider';
import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

const initialValues = {
  accountholder: { sameApplicant: true },
};

const FrontOfficeStorage = (): ReactElement => {
  return (
    <AccountholderStorageProvider initialValues={initialValues}>
      <Outlet />
    </AccountholderStorageProvider>
  );
};

FrontOfficeStorage.displayName = 'Front office storage component';

export default FrontOfficeStorage;
